export default function CardView({
  title = 'Card View',
  color,
  textColor = '#000',
  width = '100%',
  height = 'auto',
  children = null,
  onClick,
}: Readonly<{
  title?: string;
  color?: string;
  textColor?: string;
  children?: React.ReactNode;
  width?: string;
  height?: string;
  onClick?: () => void;
}>) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  const containerStyle: React.CSSProperties = {
    color: textColor,
    border: '1px solid #ccc',
    borderRadius: '8px',
    padding: '20px',
    margin: '16px 0',
    backgroundColor: color,
    width: width,
    height: height,
    transition: 'all 0.2s ease',
  };

  const clickableStyle: React.CSSProperties = onClick
    ? {
        ...containerStyle,
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      }
    : containerStyle;

  if (onClick) {
    return (
      <button
        type="button"
        style={{
          ...clickableStyle,
          border: '1px solid #ccc',
          textAlign: 'inherit',
          font: 'inherit',
        }}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
        }}
      >
        <h3 style={{ textAlign: 'center', wordBreak: 'break-word' }}>{title}</h3>
        <div style={{ textAlign: 'center' }}>{children}</div>
      </button>
    );
  }

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center' }}>{title}</h2>
      <div style={{ textAlign: 'center' }}>{children}</div>
    </div>
  );
}
